import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SnapMark } from "@/components/SnapMark";
import { STUDIO } from "@/lib/studio";
import { useEvent } from "@/context/EventContext";

const fade = (delay) => ({
  initial: { opacity: 0, y: 14, filter: "blur(8px)" },
  animate: { opacity: 1, y: 0, filter: "blur(0px)", transition: { delay, duration: 0.7, ease: [0.16, 1, 0.3, 1] } },
});

export const Intro = ({ onDone }) => {
  const { event } = useEvent();
  useEffect(() => {
    const t = setTimeout(onDone, 4600);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-50 flex cursor-pointer flex-col items-center justify-center bg-[#05020a] text-center"
        onClick={onDone}
        exit={{ opacity: 0, scale: 1.04, transition: { duration: 0.6 } }}
        data-testid="intro-splash"
      >
        <div className="pointer-events-none absolute inset-0 overflow-hidden">
          {Array.from({ length: 28 }).map((_, i) => (
            <span key={`intro-star-${i}`} className="star" style={{ left: `${(i * 37) % 100}%`, top: `${(i * 53) % 100}%`, animationDelay: `${(i % 7) * 0.35}s` }} />
          ))}
          <motion.div
            className="absolute left-1/2 top-1/2 h-[60vmin] w-[60vmin] -translate-x-1/2 -translate-y-1/2 rounded-full"
            style={{ background: "radial-gradient(circle, rgba(230,0,126,0.35), rgba(78,0,82,0.25) 40%, transparent 70%)" }}
            initial={{ scale: 0.4, opacity: 0 }}
            animate={{ scale: [0.4, 1.1, 1], opacity: [0, 1, 0.8] }}
            transition={{ duration: 2.4, delay: 1.6 }}
          />
        </div>
        <motion.p className="eyebrow relative" {...fade(0.2)}>{STUDIO.name}</motion.p>
        <motion.p className="relative mt-3 text-sm italic tracking-wide text-slate-400" {...fade(0.8)}>presents</motion.p>
        <motion.div className="relative mt-4 flex items-center gap-4" {...fade(1.3)}>
          <motion.span initial={{ rotate: -90, scale: 0.6 }} animate={{ rotate: 0, scale: 1 }} transition={{ delay: 1.3, duration: 1.1, ease: [0.16, 1, 0.3, 1] }}>
            <SnapMark size={60} />
          </motion.span>
          <span className="font-display text-6xl font-black tracking-tight sm:text-7xl">{STUDIO.product}</span>
        </motion.div>
        <motion.div className="relative mt-10" {...fade(2.6)}>
          <p className="eyebrow">{event?.organizer_note || ""}</p>
          <p className="font-display mt-2 text-2xl font-extrabold text-[var(--accent-soft)] sm:text-3xl" data-testid="intro-event-subtitle">
            {event?.event_subtitle || ""}
          </p>
        </motion.div>
        <motion.p className="absolute bottom-8 text-xs text-slate-500" initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { delay: 3.2 } }}>
          Geçmek için dokun
        </motion.p>
      </motion.div>
    </AnimatePresence>
  );
};
